import { QueryParams } from "./SiteTools";

/**
 * It waits 2 seconds before calling the pageview function.
 * @param stepNumber - The step number that the user is currently on.
 */
export const loadPageView = (stepNumber) => {
    const waitBactm = () => {
        if(window.bactm !== undefined){
            window.bactm.rescanDOM();
            window.bactm.pageview(stepNumber);
            QueryParams();
        }
        else{
            setTimeout(waitBactm, 250);
        }
    }
    waitBactm();
};